/* ============================================================
   Переключатель языка в шапке.
   ============================================================ */
import { applyLang, getLang, onLangChange } from '../i18n';
import { byId } from '../dom';
import type { Lang } from '../types';

export function initLangSwitch(): void {
  const root = byId('lang');
  const trigger = byId<HTMLButtonElement>('langTrigger');
  const current = byId('langCurrent');

  function close(): void {
    root.dataset.open = '0';
    trigger.setAttribute('aria-expanded', 'false');
  }

  function toggle(): void {
    const isOpen = root.dataset.open === '1';
    root.dataset.open = isOpen ? '0' : '1';
    trigger.setAttribute('aria-expanded', String(!isOpen));
  }

  function syncLabel(lang: Lang): void {
    current.textContent = lang.toUpperCase();
  }

  syncLabel(getLang());
  onLangChange((_dict, lang) => syncLabel(lang));

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    toggle();
  });

  root.addEventListener('click', (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLButtonElement>('button');
    const lang = btn?.dataset.lang;
    if (lang === 'ru' || lang === 'en' || lang === 'fr') {
      applyLang(lang as Lang);
      close();
    }
  });

  document.addEventListener('click', (e) => {
    if (!root.contains(e.target as Node)) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}
